const SvgEnvelope = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" xmlSpace="preserve" width="1em" height="1em">
		<path
			d="M922.9 136.3H77.1C40.2 136.3 10 166.8 10 204v592c0 37.2 30.2 67.7 67.1 67.7h845.7c36.9 0 67.1-30.4 67.1-67.7V204c.1-37.2-30.1-67.7-67-67.7zm-41.2 56.3-367 315c-12.5 12.7-12.5 12.7-25.1 0l-366.9-315h759zm53.2 583.9L698.5 523.1c-13.1-13.2-34.3-13.2-47.5 0-13.1 13.2-13.1 34.6 0 47.8L864.9 808H143.8l213.9-237.1c13.1-13.2 13.1-34.6 0-47.8-13.1-13.2-34.3-13.2-47.5 0L66 780.7v-540l376.2 314.8c19 19.1 35.2 33.3 62.1 33.3s39-14.2 57.9-33.3l372.6-314.8v535.8h.1z"
			fill="#100D3D"
		/>
	</svg>
)

export default SvgEnvelope
